import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ESIGN_MESSAGE } from '../../utils/utilityFunctions';

export function PaymentSuccessPopup({
  onClose,
  onClickOk,
  okDisabled = false,
}: {
  onClose: () => void;
  onClickOk: () => void | Promise<void>;
  okDisabled?: boolean;
}): JSX.Element {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '600px', md: '700px' },
          borderRadius: 3,
          p: 1,
        },
      }}>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 22,
          pb: 1,
        }}>
        Payment Initiated
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 4, py: 2 }}>
        <Box display="flex" justifyContent="center" mb={1}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 48 }} />
        </Box>

        <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
          Your payment has been initiated successfully.
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Please proceed with E-Sign to complete the process.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          pb: 3,
          pt: 1,
        }}>
        <Button
          onClick={() => void onClickOk()}
          disabled={okDisabled}
          variant="contained"
          fullWidth
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.4,
            fontSize: 16,
          }}>
          OK, Proceed with e-Sign
        </Button>
      </DialogActions>
      <Typography
        sx={{
          mt: 2,
          fontSize: 14,
          fontWeight: 700,
          color: 'text.primary',
          lineHeight: 1.7,
          textAlign: 'center',
        }}>
        ** {ESIGN_MESSAGE} **
      </Typography>
    </Dialog>
  );
}
